import { type ColumnDef, createColumnHelper } from '@tanstack/react-table'

import { getTranslation } from '~/tools/utils'
import type { ProductFormSchema, StockUnitFormSchema } from '../hooks/useProductForm'

export function createDimensionsColumns(
    dimensions: ProductFormSchema['dimensions'],
    language: string
): ColumnDef<StockUnitFormSchema, string | null>[] {
    const columnHelper = createColumnHelper<StockUnitFormSchema>()

    return dimensions.map((dimension, dimensionIndex) => {
        return columnHelper.display({
            id: dimension.id.toString(),
            cell: ({ row }) => {
                const dimensionOption = row.original.dimension_options.find(
                    (option) => option.product_dimension.index === dimensionIndex
                )

                if (!dimensionOption) {
                    return null
                }

                const matchingDimensionOption = dimension.options.find(
                    (option) => option.id === dimensionOption.id
                )

                if (!matchingDimensionOption) {
                    return null
                }

                const optionTranslation = getTranslation(
                    matchingDimensionOption,
                    language,
                    'option'
                )

                return optionTranslation
            },
            header: () => (
                <span style={{ textTransform: 'capitalize' }}>
                    {getTranslation(dimension, language, 'name')}
                </span>
            ),
        })
    })
}
